interface ChatBubbleProps {
  text: string;
  senderRole: "patient" | "admin";
  createdAt: string;
  seen: boolean;
}

function formatTime(dateStr: string): string {
  const d = new Date(dateStr);
  return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

export function ChatBubble({
  text,
  senderRole,
  createdAt,
  seen,
}: ChatBubbleProps) {
  const isAdmin = senderRole === "admin";
  return (
    <div
      className={`fadfaddah-bubble ${isAdmin ? "fadfaddah-bubble--sent" : "fadfaddah-bubble--received"}`}
    >
      <div className="fadfaddah-bubble-text">{text}</div>
      <div className="fadfaddah-bubble-meta">
        <span>{formatTime(createdAt)}</span>
        {isAdmin && (
          <span className="fadfaddah-bubble-seen">{seen ? "✓✓" : "✓"}</span>
        )}
      </div>
    </div>
  );
}
